import React from 'react';
import { ReactSelect } from '@softura/customcomponent';
import './dropdown.scss';

interface Iprops {
    options: DROPDOWN_INTER[],
    isSearchable?: boolean,
    isLoading?: boolean,
    placeholder: any,
    className?: string,
    isMulti?: boolean,
    onChange?: Function,
    value?: any,
    allowSelectAll?: boolean,
    hideSelectedOptions?: boolean,
    closeMenuOnSelect?: boolean,
    onBlur?: any
}
interface DROPDOWN_INTER {
    value?: string;
    label?: string;
}


const Dropdownwithsearch = ({ value, closeMenuOnSelect, onBlur, allowSelectAll, onChange, options, isSearchable, isLoading, placeholder, className, isMulti }: Iprops) => {
    const customStyles = {
        option: (provided: any, state: any) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#140a9a' : '',
            color: state.isSelected ? '#fff' : state.isDisabled ? '#ccc' : '#333',
        }),

    }
    const updatedOptions = isMulti
        ? [{ label: "Select All", value: "all" }, ...options]
        : options;
    return (
        <ReactSelect
            styles={customStyles}
            onChange={(selected: any) => {
                onChange && (isMulti &&
                    selected.length &&
                    selected.find((item: any) => item.value === "all")
                    ? onChange(updatedOptions.slice(1))
                    : !isMulti
                        ? onChange(selected || null)
                        : onChange(selected))
            }}
            allowSelectAll={allowSelectAll}
            closeMenuOnSelect={closeMenuOnSelect}
            // hideSelectedOptions={hideSelectedOptions}
            options={updatedOptions}
            value={value}
            isSearchable={isSearchable}
            isLoading={isLoading}
            placeholder={placeholder}
            onblur={onBlur}
            className={`customDropdown ${className}`}
            isMulti={isMulti} />
    )
}

export default Dropdownwithsearch;
